import React, { useState,useEffect } from 'react'
import { AccessAlarm, Add, Check, Edit, FindReplace, Pending, PendingActions } from '@mui/icons-material';
import moment from 'moment'
function TaskDuration({dateTime}) {


    const [diff,setDiff] = useState("")
    const [color,setColor] = useState("")

    const getDuration = () =>{
        let eod = moment(dateTime)
        let now = moment();
        let _diff = eod.diff(now,'hours')
        //console.log(_diff)
        _diff+=24;
        
        if(_diff < 0){
            setDiff("overdue")
            setColor("bg-danger blink-infinite text-white")
        }

        if(_diff >= 0 && _diff <= 24 ){
            setDiff("today");
            setColor("bg-danger text-white")
        }

        if(_diff > 24 ){
            setDiff("tomorrow");
            setColor("bg-warning text-dark")
        }

        if(_diff > 48 ){
            setDiff("later");
            setColor("bg-success text-white")
        }

        

        

        //setDiff(_diff)

    }

    useEffect(()=>{
        getDuration()
    },[])

    return (
        <span className={"badge px-1 ms-1 "+color}> <AccessAlarm sx={{fontSize:12}} />{diff} </span>
    )
}

export default TaskDuration